import React, { Component } from "react"
import * as SelectionFactoryHelper from "../../../helpers/SelectionFactoryHelper"

export default class MerchantPageSpotProducts extends Component {
  render() {
    return (
      <div className="shoppage__productband">
        <div className="shoppage__productband__content">
          {this.props.spotProducts &&
            this.props.spotProducts.map((spotProduct, index) => {
              return <SpotProduct key={index} {...this.props} {...spotProduct} />
            })}
        </div>
      </div>
    )
  }
}

class SpotProduct extends Component {
  render() {
    const buttonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.buttonColor)
    const backgroundColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.backgroundColor)
    const buttonStyle = this.props.buttonTextColor ? { color: this.props.buttonTextColor } : undefined
    return (
      <div className={`product ${backgroundColor && backgroundColor}`}>
        <div className="product-image">
          <img src={this.props.image} data-epi-edit="Image" />
        </div>
        <div className="name" data-epi-edit="ProductHeadline">
          {this.props.productHeadline}
        </div>
        <div className="description" data-epi-edit="ProductDescription">
          {this.props.productDescription}
        </div>
        <div className="price" data-epi-edit="Valuta">
          <span data-epi-edit="ProductPrice">{this.props.productPrice}</span> {this.props.valuta}
        </div>
        <div className="ctabutton">
          <a href={this.props.buttonLink}>
            <div style={buttonStyle} className={`button button--small no-shadow ${buttonColor && buttonColor}`}>
              <span className="text" data-epi-edit="ButtonText">
                {this.props.buttonText}
              </span>
            </div>
          </a>
        </div>
      </div>
    )
  }
}
